import { Grid, Typography, styled } from "@mui/material";
import { useEffect } from "react";

import useDispatch from "hooks/useDispatch";
import { getMarketLoggedInForm } from "store/slices/market/marketSlice";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Select from "components/Select";
import { useForm } from "react-hook-form";
import CoinSelectItem from "components/CoinSelectItem";

function MarketTabs() {
  const dispatch = useDispatch()

  const [searchParams, setSearchParams] = useSearchParams();

  const defaultValues = {
    brokerId: searchParams.get('brokerId') || 0,
    coinSourceId: searchParams.get('coinSourceId') || -1,
    coinDestinationId: searchParams.get('coinDestinationId') || -1
  }

  const { watch, setValue } = useForm({ defaultValues });

  const marketLoggedInForm = useSelector((state) => state.market.marketLoggedInForm?.data)

  useEffect(() => {
    dispatch(getMarketLoggedInForm());

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (value, fieldName) => {
    setValue(fieldName, value);
    const allSearchParams = Object.fromEntries([...searchParams]);

    setSearchParams({
      ...allSearchParams,
      page: 1,
      [fieldName]: value,
    });
  };

  return (
    <Grid container my={2} spacing={1}>
      <Grid item xs={12} md={3}>
        <Typography color={"common.white"} variant="label">
          Brokers
        </Typography>

        <SelectStyle
          items={marketLoggedInForm?.lisBroker}
          itemValue="id"
          itemText="name"
          dir="ltr"
          value={watch('brokerId')}
          onChange={(e) => {
            handleChange(e.target.value, 'brokerId');
          }}
        />
      </Grid>

      <Grid item xs={12} md={3} >
        <Typography color={"common.white"} variant="label">
          Source Coin
        </Typography>

        <SelectStyle
          items={marketLoggedInForm?.lisCoinSource}
          itemValue="id"
          itemText="name"
          dir="ltr"
          value={watch('coinSourceId')}
          customValue={(data) => <CoinSelectItem data={data} />}
          onChange={(e) => {
            handleChange(e.target.value, 'coinSourceId');
          }}
        />
      </Grid>

      <Grid item xs={12} md={3} >
        <Typography color={"common.white"} variant="label">
          Destination Coin
        </Typography>

        <SelectStyle
          items={marketLoggedInForm?.lisCoinDestination}
          itemValue="id"
          itemText="name"
          dir="ltr"
          value={watch('coinDestinationId')}
          customValue={(data) => <CoinSelectItem data={data} />}
          onChange={(e) => {
            handleChange(e.target.value, 'coinDestinationId');
          }}
        />
      </Grid>
    </Grid>
  );
}


const SelectStyle = styled(Select)(({ theme }) => ({
  ".MuiSelect-select": {
    padding: theme.spacing(1, 2.5),
  },
}));

export default MarketTabs;
